import React from 'react';

import { withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { gql } from '@reverbdotcom/commons/src/gql';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';

interface ExternalProps {
  limit?: number;
  offset?: number;
}

export const FAVORITE_SEARCHES_QUERY = gql(`
  query Core_Get_Favorite_SearchesQuery(
    $limit: Int,
    $offset: Int
  ) {
    me {
      _id
      uuid
      favorites(input: {
        type: SAVED_SEARCH
        limit: $limit
        offset: $offset
      }) {
        favorites {
          id
          title
          subtitle
          listingsSearchUrlParams
          favorite {
            id
            title
            subtitle
            favorited
            feedEnabled
            emailEnabled
            queryParams
            link {
              href
            }
          }
        }
      }
    }
  }`);

export default function withFavoriteSearches<IProps>(
  Component: React.ComponentType<IProps>,
): React.ComponentType<IProps> {
  const requestConfig = {
    options: (ownProps: ExternalProps) => {
      return {
        ssr: false,
        variables: {
          limit: ownProps.limit || 6,
          offset: ownProps.offset || 0,
        },
      };
    },
    props({ data, ownProps }) {
      const { loading, me } = data;

      const props = {
        ...ownProps,
        favoriteSearches: me?.favorites?.favorites || [],
        loadingFavoriteSearches: loading,
      };
      return props;
    },
  };
  return withUserContext(withGraphql(FAVORITE_SEARCHES_QUERY, requestConfig)(Component)) as React.ComponentType<IProps>;
}
